import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import * as R from 'ramda';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { AggregatedPurchasedItemOptionValue } from 'apis/merchant-gateway/merchant-analytics/types';
import { typographyCss } from 'common/typography';
import { localize } from 'common/utils';

import ItemOptionValueRow from './ItemOptionValueRow';

const groupByOptionId: (
  list: AggregatedPurchasedItemOptionValue[],
) => [string, AggregatedPurchasedItemOptionValue[]][] = R.pipe(
  R.groupBy(R.prop('optionId')),
  R.toPairs,
  // Map over the pairs to ensure each key maps to a non-empty array (this is to satisfy typescript)
  R.map(([key, value]) => [key, value || []]),
);
const Heading = styled.div`
  ${typographyCss.Small};
  margin-block-start: 24px;
  line-height: 1.5;
  color: ${cbSemanticCssVars.textPrimary};
`;
const ItemOptionValueV2 = ({
  optionValue: {
    optionValueId,
    count,
    pricing: { finalPrice },
    optionValueProduct: { names: optionName },
  },
  currency,
}: {
  optionValue: AggregatedPurchasedItemOptionValue;
  currency: Currency;
}) => {
  const { locale } = useIntl();

  return (
    <ItemOptionValueRow
      key={optionValueId}
      count={count}
      name={localize(optionName, locale)}
      amount={finalPrice.gross}
      currency={currency}
    />
  );
};
const ItemOptionsSection = ({
  itemOptions = [],
  currency,
}: {
  itemOptions: AggregatedPurchasedItemOptionValue[];
  currency: Currency;
}) => {
  const { locale } = useIntl();

  return (
    <>
      {groupByOptionId(itemOptions).map(([optionId, optionValues]) => (
        <div key={optionId}>
          <Heading>{localize(optionValues[0].optionProduct.names, locale)}</Heading>
          {optionValues.map(optionValue => (
            <ItemOptionValueV2 key={optionValue.optionValueId} optionValue={optionValue} currency={currency} />
          ))}
        </div>
      ))}
    </>
  );
};

export default ItemOptionsSection;
